import s from "./Categories.module.css";
import img1 from "../../img/categories/1.jpg";
import img2 from "../../img/categories/2.jpg";
import img3 from "../../img/categories/3.jpg";
import img4 from "../../img/categories/4.jpg";
import {useEffect} from "react";


const CategorySection = (props) => {
    useEffect(() => {
        props.getTitle(props.title);
    }, [props.title])

    return (
        <section className={s.category}>
            <h3>{props.title}</h3>
            <div className={s.categoryItems}>
                <div className={s.categotyItem}>
                    <img src={img1} alt=""/>
                    <div className={s.categotyItemTitile}><p>Бязь-ранфорс (31)</p></div>
                </div>
                <div className={s.categotyItem}>
                    <img src={img2} alt=""/>
                    <div className={s.categotyItemTitile}><p>Сатин-Жаккард (12)</p></div>
                </div>
                <div className={s.categotyItem}>
                    <img src={img3} alt=""/>
                    <div className={s.categotyItemTitile}><p>Сатин-Люкс (10)</p></div>
                </div>
                <div className={s.categotyItem}>
                    <img src={img4} alt=""/>
                    <div className={s.categotyItemTitile}><p>Сатин-Твил (52)</p></div>
                </div>
            </div>
            <div className={s.categoryDescription}>
                <div><h3>СОЗДАМ УЮТ: КУПИТЬ ПОСТЕЛЬНОЕ БЕЛЬЕ</h3>
                    <p>Сон является важным этапом жизненного цикла человека. Мы высыпаемся, спим и насколько
                        полноценный этот сон - настолько мы бодры и здоровы. Не последнее значение для
                        полноценного ночного отдыха оказывают постельные аксессуары. Именно поэтому комплект
                        постельного белья - замечательная инвестиция в собственное благополучие.</p></div>
                <div>
                    <h3>ПАРАМЕТРЫ ПОИСКОВ</h3>
                    <p>Итак, пришло время купить постельное белье. Первое, о чем думает среднестатистический
                        покупатель – это размеры и расцветка. Но так ли это важно в действительности?
                        Покупая спальный набор, нужно помнить, что постель – это предмет интерьера, который
                        требует тщательной и регулярной стирки при температуре от 60 градусов.
                        Соответственно, постельное должно быть качественное. В противном случае оно быстро
                        потеряет свой привлекательный внешний вид, покроется катышками и спать на нем будет
                        просто неприятно.
                    </p>
                    <h5>Вот основные параметры, которым должен соответствовать постельный гарнитур:</h5>
                    <ul>
                        <li>Текстиль должен быть прочным. И чем выше эта прочность - тем лучше. К счастью,
                            если ткань не плотная, то это легко заметить при ближайшем рассмотрении;
                        </li>
                        <li>Приятный нейтральный аромат или полное отсутствие запаха. Если комплект веет
                            сыростью, плесенью или химическими красителями – этот товар не для вас;
                        </li>
                        <li>Тактильные ощущения – важное условие. Продукт должен нравиться вам наощупь;
                        </li>
                        <li>Прочность и привлекательность упаковки;
                        </li>
                        <li>Правильные швы, а именно бельевые, соответствующие расцветке основного
                            комплекта. Никаких оборванных, незаправленных ниток!
                        </li>
                        <li> Спальное белье с вышивкой и орнаментом при контакте не травмирует кожу. Чтобы
                            это проверить – проведите оборкой по тыльной стороне. Как ощущения?;
                        </li>
                        <li>Семейное постельное, имеющее хорошее качество, шьют из целого отреза. А значит,
                            швов по центру нет;
                        </li>
                        <li>Хорошее - априори не шьют из ярких тканей с кричащим орнаментом. Красивое – не
                            значит пестрое;
                        </li>
                        <li>Упаковка содержит детальную информацию о товаре. Его размеры, производитель,
                            особенности ухода и состав;
                        </li>
                        <li>Дешево не бывает синонимом качества. Да, цена должна быть разумной, но слишком
                            низкая стоимость даже от производителя больше настораживает, чем радует.
                        </li>
                    </ul>
                </div>
                <div>
                    <h3>КУПИТЬ ПОСТЕЛЬНОЕ БЕЛЬЕ ДЛЯ РЕБЕНКА</h3>
                    <p>Если вы выбираете спальный комплект в кроватку, то это выбор с особой
                        ответственностью. Для своего чада хочется купить лучшее из лучшего. Очень часто, за
                        рядом дополнительных аксессуаров, включенных в комплект, скрывается низкое качество
                        материала. Обратите внимание, что фабрика обычно предлагает стандартные набор,
                        включающий простынь, пододеяльник и наволочку. А все дополнительные аксессуары можно
                        заказать отдельно. Это говорит не о дурном вкусе менеджеров предприятия, а об
                        ответственном подходе к производству. Что должно вызывать доверие.</p>
                </div>
                <div>
                    <h3>ГДЕ КУПИТЬ ПОСТЕЛЬНОЕ БЕЛЬЕ</h3>
                    <p>Мало какого покупателя не интересует, сколько стоит желаемый товар. Как показывает
                        практика, недорого предложить постельное белье может интернет-магазин. Причем не
                        зависимо от того, желаете ли вы сделать покупку оптом или в розницу.

                        Цена будет одинаковой, если заказать, например, в городе Полтава или в любом городе
                        страны. Украина - страна с хорошо развитой почтовой коммуникацией. Поэтому оформить
                        доставку в любой из ее регионов не будет проблемой. Долой сомнения – пришло время
                        проверить! Заказывайте сами и рекомендуйте нас друзьям – вы не пожалеете!
                    </p>
                </div>
            </div>
        </section>
    );
}

export default CategorySection;